import React, { useState } from 'react';
import axios from '../../api/axios';

const EARNINGS_URL = '/api/earnings/subtract';

const EarningsModal = ({ onClose, totalEarnings, earningsByZone }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await axios.put(EARNINGS_URL, {
        amount: Number(amount),
        description,
        date: new Date().toISOString(),
      });
  
      if (response.status === 200) {
        window.location.reload();
        onClose();
      }
    } catch (err) {
      setError('Failed to deduct earnings. Please try again.');
      console.error('Error deducting earnings:', err);
    }
  };  

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-[#610c63]">Take Earnings</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>

        <div className="mb-6 space-y-2">
          <div className="flex justify-between p-3 bg-purple-50 rounded">
            <span className="text-gray-600">Total Earnings:</span>
            <span className="font-semibold text-[#610c63]">{totalEarnings}</span>
          </div>
          <div className="flex justify-between p-3 bg-purple-50 rounded">
            <span className="text-gray-600">Salon Earnings:</span>
            <span className="font-semibold text-[#610c63]">
              {new Intl.NumberFormat('fr-MA', {
                style: 'currency',
                currency: 'MAD'
              }).format(earningsByZone.salon)}
            </span>
          </div>
          <div className="flex justify-between p-3 bg-purple-50 rounded">
            <span className="text-gray-600">Rooftop Earnings:</span>
            <span className="font-semibold text-[#610c63]">
              {new Intl.NumberFormat('fr-MA', {
                style: 'currency',
                currency: 'MAD'
              }).format(earningsByZone.rooftop)}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Amount to Take
            </label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:ring-[#610c63] focus:border-[#610c63]"
              required
              min="0"
              step="0.01"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description
            </label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded focus:ring-[#610c63] focus:border-[#610c63]"
              required
              placeholder="Enter reason for taking earnings"
            />
          </div>

          {error && (
            <div className="text-red-500 text-sm mt-2">
              {error}
            </div>
          )}

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-[#610c63] rounded hover:bg-[#4a0a4c]"
            >
              Confirm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EarningsModal;